import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`

export const Label = styled.label`
  display: block;
  position: relative;
  z-index: 1;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 5px;
  width: fit-content;
`

export const FormErrorMessage = styled.div`
  margin-left: 20px;
  color: ${({ theme }) => theme.colors.brightRed};
  font-size: 14px;
`
